import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import { Form } from "@unform/web";
import * as Yup from "yup";
import getValidationErrors from "../../../../utils/getValidationErrors";
import { validateDocument } from "../../../../utils/documentValidation";

import { useSelector } from "react-redux";

import { FormattedMessage, useIntl } from "react-intl";

import {
  Container,
  TitleContainer,
  Title,
  Session,
  FieldsContainer,
  ActionContainer,
  BadgeContainer,
} from "./styles";

import CpfCnpj from "../../../../components/CpfCnpj";

import { useToast } from "../../../../hooks/toast";
import { validateSingleFieldOnBlur } from "../../../../utils/formValidations";
import api from "../../../../service";
import AnimatedMainContainer from "../../../../components/AnimatedMainContainer";
import InputWithHorizontalLabel from "../../../../components/InputWithHorizontalLabel";
import SelectWithLabel from "../../../../components/SelectWithLabel";
import Badge from "../../../../components/Badge";
import { useLoading } from "../../../../hooks/loading";
import axios from "axios";
import { getCountries } from "react-phone-number-input/input";
import countryListEn from "react-phone-number-input/locale/en";
import countryListPt from "react-phone-number-input/locale/pt";
import Toggle from "../../../../components/Toggle";
import
  TelephoneInputWithLabel,
  {
    getFullTelephoneNumber,
    getCountryFromTelephoneNumber,
  }
from "../../../../components/TelephoneInputWithLabel";
import {
  getBrazilianStates,
  getBrazilianCitiesByStateId,
} from "../../../../service/localities.service";

const AdminAssociateCollaboratorsDetail = () => {
  const formRef = useRef(null);
  const intl = useIntl();
  const { id } = useParams();
  const { addToast } = useToast();
  const { token } = useSelector((state) => state.auth);
  const [data, setData] = useState(null);
  const [key, setKey] = useState(null);
  const { handleLoading } = useLoading();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState();
  const [personType, setPersonType] = useState("F");
  const [selectedUser, setSelectedUser] = useState();
  const [isFastTrack, setIsFastTrack] = useState(false);
  const [selectedRoleType, setSelectedRoleType] = useState();
  const [countries, setCountries] = useState([]);
  const [brazilianStates, setBrazilianStates] = useState([]);
  const [brazilianCities, setBrazilianCities] = useState([]);
  const [hasLoadedCity, setHasLoadedCity] = useState(false);
  const isPortuguese = intl.locale === "pt";

  const [documentLabel, setDocumentLabel] = useState(
    intl.formatMessage({ id: "document_cpf" })
  );

  const nationalityOptions = [
    {
      label: intl.formatMessage({ id: "national" }),
      value: false,
    },
    {
      label: intl.formatMessage({ id: "international" }),
      value: true,
    },
  ];

  const roleTypes = [
    {
      label: intl.formatMessage({ id: "exhibitor" }),
      value: "EXHIBITOR",
    },
    {
      label: intl.formatMessage({ id: "sponsor_without_m2" }),
      value: "SPONSOR_WITHOUT_M2",
    },
    {
      label: intl.formatMessage({ id: "service_provider" }),
      value: "SERVICE_PROVIDER",
    },
  ];

  const history = useHistory();

  const schema = Yup.object().shape({
    roleType: Yup.string().required(
      intl.formatMessage({ id: "error.field_required" })
    ),
    user: Yup.string().required(
      intl.formatMessage({ id: "error.field_required" })
    ),
    nationality: Yup.string().required(
      intl.formatMessage({ id: "error.field_required" })
    ),
    name: Yup.string().required(
      intl.formatMessage({ id: "error.field_required" })
    ),
    last_name: Yup.string().required(
      intl.formatMessage({ id: "error.field_required" })
    ),
    document: Yup.string()
      .required(intl.formatMessage({ id: "error.field_required" }))
      .test(
        "document-validation",
        "",
        function (value) {
          if (!value) return true;

          const formData = this.parent;
          const nationalityField = formData.nationality;

          let isInternational = false;

          if (typeof nationalityField === 'object' && nationalityField !== null) {
            isInternational = nationalityField.value === true;
          } else if (typeof nationalityField === 'boolean') {
            isInternational = nationalityField;
          } else if (typeof nationalityField === 'string') {
            isInternational = nationalityField === 'true' || nationalityField === true;
          }

          // personType validation as fallback
          if (typeof isInternational === 'undefined') {
            isInternational = personType === "I";
          }

          const validation = validateDocument(value, isInternational, intl);

          if (!validation.isValid && validation.message) {
            return this.createError({ message: validation.message });
          }

          return true;
        }
      ),
    assignment: Yup.string()
      .max(50, intl.formatMessage({ id: "error.max_length" }, { length: 50 }))
      .required(intl.formatMessage({ id: "error.field_required" })),
    credential_name: Yup.string()
      .max(23, intl.formatMessage({ id: "error.max_length" }, { length: 23 }))
      .required(intl.formatMessage({ id: "error.field_required" })),
    email: Yup.string()
      .email(intl.formatMessage({ id: "error.valid_email" }))
      .nullable()
      .when("fast_track", {
        is: (fast_track) => !fast_track,
        then: Yup.string()
          .nullable()
          .required(
            intl.formatMessage({
              id: "error.field_required",
            })
          ),
      }),
    country: Yup.string()
      .nullable()
      .when("nationality", {
        is: "true",
        then: Yup.string()
          .nullable()
          .required(
            intl.formatMessage({
              id: "error.field_required",
            })
          )
          .test(
            "not-empty",
            intl.formatMessage({ id: "error.field_required" }),
            (value) => value && value.trim().length > 0
          ),
      }),
    internationalCity: Yup.string()
      .nullable()
      .when("nationality", {
        is: "true",
        then: Yup.string()
          .nullable()
          .required(
            intl.formatMessage({
              id: "error.field_required",
            })
          ),
      }),
    state: Yup.string()
      .nullable()
      .when("nationality", {
        is: "false",
        then: Yup.string()
          .nullable()
          .required(
            intl.formatMessage({
              id: "error.field_required",
            })
          ),
      }),
    brazilianCity: Yup.string()
      .nullable()
      .when("nationality", {
        is: "false",
        then: Yup.string()
          .nullable()
          .required(
            intl.formatMessage({
              id: "error.field_required",
            })
          ),
      }),
    telephone: Yup.string()
      .max(30, intl.formatMessage({ id: "error.max_length" }, { length: 30 }))
      .required(intl.formatMessage({ id: "error.field_required" })),
  });

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});

        await schema.validate(data, { abortEarly: false });
        
        setLoading(true);
        if (loading) {
          return;
        }

        api
          .put(
            `/associate-collaborators/admin/${id}`,
            {
              fastTrack: isFastTrack,
              userId: data.user,
              international: data.nationality,
              name: data.name,
              lastName: data.last_name,
              credentialName: data.credential_name,
              document: data.document,
              jobTitle: data.assignment,
              email: data.email,
              country: data.country,
              city: data.nationality
                ? data.internationalCity
                : data.brazilianCity,
              state: data.state,
              telephone: getFullTelephoneNumber(
                data.telephone, data.telephone_selected_country),
            },
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((result) => {
            setLoading(false);
            addToast({
              type: "success",
              title: intl.formatMessage({
                id: "success",
              }),
              description: intl.formatMessage({
                id: "success.collaborator_update",
              }),
            });
            history.go(-2);
          })
          .catch((err) => {
            setLoading(false);
            addToast({
              type: "error",
              title: intl.formatMessage({
                id: "error",
              }),
              description: intl.formatMessage({
                id: "api.error." + err.response.data.code,
              }),
            });
          });
      } catch (err) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }
      }
    },
    [addToast, history, id, intl, schema, token, loading, isFastTrack]
  );

  useEffect(() => {
    handleLoading(true);

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .all([
        api.get(`/associate-collaborators/admin/${id}`, config),
      ])
      .then(
        axios.spread(async (collaboratorResponse) => {
          setData(collaboratorResponse.data.associateCollaboratorOutput);
          switch (
            collaboratorResponse.data.associateCollaboratorOutput.international
          ) {
            case false:
              setPersonType("F");
              setDocumentLabel(
                intl.formatMessage({ id: "document_cpf" })
              );
              break;
            case true:
              setPersonType("I");
              setDocumentLabel(
                intl.formatMessage({ id: "document_passport" })
              );
              break;
            default:
              break;
          }

          const userId = collaboratorResponse.data.associateCollaboratorOutput.userId;
          const userRoleType = collaboratorResponse.data.associateCollaboratorOutput.userRoleType;
          setSelectedRoleType(userRoleType);
          setIsFastTrack(collaboratorResponse.data.associateCollaboratorOutput.fastTrack);

          return {
            userId,
            usersResponse: await api.get(
              `/users/active-clients-by-type`, {
                params: {
                  role_type: userRoleType,
                },
                headers: config.headers,
            }),
          };
        })
      )
      .then(({ userId, usersResponse }) => {
        const users = usersResponse.data.users.map((user) => ({
          label: user.commercialName,
          value: user.id,
        }));
        setUsers(users);

        handleUserItemSelection(users, userId);
        setKey(new Date());
      })
      .catch((error) =>
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + error.response.data.code,
          }),
        })
      )
      .finally(() => {
        handleLoading(false);
      });
  }, [addToast, id, intl, token, handleLoading]);

  const handleUserItemSelection = (users, id) => {
    const initialUser = users.find((user) => user.value === id);
    setSelectedUser(initialUser);
  };

  const validationBlur = useCallback((name) => {
    let errors = formRef.current.getErrors();

    if (name === 'document') {
      formRef.current.setFieldError('document', '');
    }

    validateSingleFieldOnBlur(errors, schema, name, formRef);
  }, [schema]);

  const handleTypeChanges = (value) => {
    setData((prevData) => ({
      ...prevData,
      city: "",
    }));
    formRef.current.setFieldValue("document", "");
    formRef.current.setFieldValue("country", "");
    formRef.current.setFieldValue("internationalCity", "");
    formRef.current.setFieldValue("state");
    formRef.current.setFieldValue("brazilianCity");
    setBrazilianCities([]);

    formRef.current.setErrors({});

    setTimeout(() => {
      const documentField = formRef.current.getFieldRef("document");
      if (documentField && documentField.current) {
        documentField.current.focus();
        documentField.current.blur();
      }
    }, 100);
    
    switch (value) {
      case false:
        setPersonType("F");
        setDocumentLabel(`${intl.formatMessage({ id: "document" })} (CPF)`);
        break;
      case true:
        setPersonType("I");
        setDocumentLabel(
          `${intl.formatMessage({ id: "document" })} (${intl.formatMessage({
            id: "passport",
          })})`
        );
        break;
      default:
        setPersonType("F");
        setDocumentLabel(`${intl.formatMessage({ id: "document" })} (CPF)`);
        break;
    }
  };

  useEffect(() => {
    formRef.current.setFieldValue("user");
    if (selectedRoleType) {
      handleLoading(true);
      api
        .get(`/users/active-clients-by-type`, {
          params: {
            role_type: selectedRoleType,
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((result) => {
          const users = result.data.users.map((user) => ({
            label: user.commercialName,
            value: user.id,
          }));
          setUsers(users);
        })
        .catch((err) => {
          addToast({
            type: "error",
            title: intl.formatMessage({
              id: "error",
            }),
            description: intl.formatMessage({
              id: "api.error." + err.response.data.code,
            }),
          });
        })
        .finally(() => {
          handleLoading(false);
        });
    }
  }, [selectedRoleType, addToast, intl, token, handleLoading]);

  useEffect(() => {
    if (!data
      || data.international
      || brazilianStates.length === 0) return;

    const originalState = data.state || "[]";

    const foundState = brazilianStates.find(
      (state) => state.value === originalState
    );
    if (foundState) {
      fetchBrazilianCities(foundState.stateId);
    } else {
      setHasLoadedCity(true);
      addToast({
        type: "warning",
        title: intl.formatMessage({
          id: "warning",
        }),
        description: intl.formatMessage(
          { id: "state_not_found" },
          { state: originalState },
        ),
      });
    }
  }, [data, brazilianStates]);

  useEffect(() => {
    if (!data
      || data.international
      || brazilianCities.length === 0
      || hasLoadedCity) return;

    const originalCity = data.city || "[]";

    const foundCity = brazilianCities.find(
      (city) => city.value === originalCity
    );
    if (!foundCity) {
      addToast({
        type: "warning",
        title: intl.formatMessage({
          id: "warning",
        }),
        description: intl.formatMessage(
          { id: "city_not_found" },
          { city: originalCity },
        ),
      });
    }

    setHasLoadedCity(true);
  }, [data, brazilianCities]);

  const fetchBrazilianCities = async (stateId) => {
    try {
      handleLoading(true);
      const cities = await getBrazilianCitiesByStateId(stateId);
      setBrazilianCities(cities);
    } catch (error) {
      addToast({
        type: "error",
        title: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "error.loading_cities",
        }),
      });
      setBrazilianCities([]);
    } finally {
      handleLoading(false);
    }
  };

  const handleStateChange = (state) => {
    formRef.current.setFieldValue("brazilianCity");

    if (!state?.stateId) {
      setBrazilianCities([]);
      return;
    }

    fetchBrazilianCities(state.stateId);
  };

  useEffect(() => {
    const fetchBrazilianStates = async () => {
      try {
        handleLoading(true);
        const states = await getBrazilianStates();
        setBrazilianStates(states);
      } catch (error) {
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "error.loading_states",
          }),
        });
        setBrazilianStates([]);
      } finally {
        handleLoading(false);
      }
    };

    const countriesList = getCountries().map((countryCode) => ({
      value: isPortuguese ? countryListPt[countryCode] : countryListEn[countryCode],
      label: isPortuguese ? countryListPt[countryCode] : countryListEn[countryCode],
    }));
    
    const sortedCountries = countriesList.sort((a, b) => 
      a.label.localeCompare(b.label)
    );
    
    setCountries(sortedCountries);

    fetchBrazilianStates();
  }, [isPortuguese]);

  const handleRoleTypeChange = (type) => {
    setSelectedRoleType(type?.value);
    if (type?.value !== "SERVICE_PROVIDER") {
      setIsFastTrack(false);
    }
  };

  return (
    <AnimatedMainContainer>
      <Container>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          key={key}
          initialData={{
            fast_track: isFastTrack,
            roleType: {
              label: roleTypes.filter(
                (type) => type.value === data?.userRoleType
              )[0]?.label,
              value: data?.userRoleType,
            },
            user: selectedUser,
            nationality: {
              label: nationalityOptions.filter(
                (v) => v.value === data?.international
              )[0]?.label,
              value: data?.international,
            },
            credential_name: data?.credentialName,
            name: data?.name,
            last_name: data?.lastName,
            document: data?.document,
            assignment: data?.jobTitle,
            email: data?.email,
            country: data?.country ? {
              label: data?.country,
              value: data?.country,
            } : null,
            internationalCity: data?.city,
            state: data?.state ? {
              label: data?.state,
              value: data?.state,
            } : null,
            brazilianCity: data?.city ? {
              label: data?.city,
              value: data?.city,
            } : null,
            telephone: data?.telephone,
            telephone_selected_country:
              getCountryFromTelephoneNumber(data?.telephone),
          }}
        >
          <TitleContainer>
            <Title>
              <FormattedMessage id="editing_collaborator" />
            </Title>
            <ActionContainer>
              <BadgeContainer
                onClick={() => history.go(-2)}
              >
                <Badge
                  color="#C9C9C9"
                  text={intl.formatMessage({ id: "goback" })}
                  fontSize="12px"
                />
              </BadgeContainer>
              <BadgeContainer onClick={() => formRef.current.submitForm()}>
                <Badge
                  color="#002244"
                  text={intl.formatMessage({ id: "save" })}
                  fontSize="12px"
                  loading={loading}
                />
              </BadgeContainer>
            </ActionContainer>
          </TitleContainer>
          <Session>
            <FieldsContainer>
              <SelectWithLabel
                name="roleType"
                validationBlur={validationBlur}
                label={intl.formatMessage({ id: "type" })}
                placeholder={intl.formatMessage({ id: "type" })}
                labelOrientation="horizontal"
                labelWidth="150px"
                options={roleTypes}
                onChange={handleRoleTypeChange}
                required
              />
              <SelectWithLabel
                name="user"
                validationBlur={validationBlur}
                label={intl.formatMessage({ id: "company" })}
                placeholder={intl.formatMessage({ id: "company" })}
                labelOrientation="horizontal"
                labelWidth="150px"
                options={users}
                required
              />
              {selectedRoleType === "SERVICE_PROVIDER" && (
                <Toggle
                  name="fast_track"
                  label={intl.formatMessage({
                    id: "fast_track",
                  })}
                  onClick={() => setIsFastTrack(!isFastTrack)}
                />
              )}
              <SelectWithLabel
                name="nationality"
                label={intl.formatMessage({ id: "nationality" })}
                placeholder={intl.formatMessage({ id: "nationality" })}
                labelOrientation="horizontal"
                labelWidth="150px"
                options={nationalityOptions}
                onChange={(e) => handleTypeChanges(e.value)}
                required
              />
              <InputWithHorizontalLabel
                name="name"
                placeholder={intl.formatMessage({
                  id: "name",
                })}
                label={intl.formatMessage({
                  id: "name",
                })}
                validationBlur={validationBlur}
                labelWidth="150px"
                required
              />
              <InputWithHorizontalLabel
                name="last_name"
                placeholder={intl.formatMessage({
                  id: "last_name",
                })}
                label={intl.formatMessage({
                  id: "last_name",
                })}
                validationBlur={validationBlur}
                labelWidth="150px"
                required
              />
              <InputWithHorizontalLabel
                name="credential_name"
                placeholder={intl.formatMessage({
                  id: "credential_name",
                })}
                label={intl.formatMessage({
                  id: "credential_name",
                })}
                description={intl.formatMessage(
                  {id: "up_to_custom_characters"},
                  {quantity: "23"},
                )}
                validationBlur={validationBlur}
                maxLength="23"
                labelWidth="150px"
                required
              />
              <CpfCnpj
                name="document"
                placeholder={documentLabel}
                label={documentLabel}
                hasLabel
                labelOrientation="horizontal"
                personType={personType}
                validationBlur={validationBlur}
                labelWidth="150px"
                required
              />
              <InputWithHorizontalLabel
                name="assignment"
                placeholder={intl.formatMessage({
                  id: "assignment",
                })}
                label={intl.formatMessage({
                  id: "assignment",
                })}
                description={intl.formatMessage(
                  {id: "up_to_custom_characters"},
                  {quantity: "50"},
                )}
                validationBlur={validationBlur}
                maxLength="50"
                labelWidth="150px"
                required
              />
              <InputWithHorizontalLabel
                name="email"
                placeholder="E-mail"
                label="E-mail"
                validationBlur={validationBlur}
                labelWidth="150px"
                required={!isFastTrack}
              />
              {personType === "I" ? (
                <>
                  <SelectWithLabel
                    name="country"
                    label={intl.formatMessage({
                      id: "country",
                    })}
                    placeholder={intl.formatMessage({
                      id: "select_country_where_live",
                    })}
                    labelOrientation="horizontal"
                    labelWidth="150px"
                    options={countries}
                    validationBlur={validationBlur}
                    isSearchable={true}
                    required
                  />
                  <InputWithHorizontalLabel
                    name="internationalCity"
                    placeholder={intl.formatMessage({
                      id: "type_city_where_live",
                    })}
                    label={intl.formatMessage({
                      id: "city",
                    })}
                    validationBlur={validationBlur}
                    labelWidth="150px"
                    maxLength="255"
                    required
                  />
                </>
              ) : (
                <>
                  <SelectWithLabel
                    name="state"
                    placeholder={intl.formatMessage({
                      id: "select_state_where_live",
                    })}
                    label={intl.formatMessage({
                      id: "state",
                    })}
                    labelOrientation="horizontal"
                    labelWidth="150px"
                    options={brazilianStates}
                    validationBlur={validationBlur}
                    isSearchable={true}
                    onChange={handleStateChange}
                    required
                  />
                  <SelectWithLabel
                    name="brazilianCity"
                    placeholder={intl.formatMessage({
                      id: "select_city_where_live",
                    })}
                    label={intl.formatMessage({
                      id: "city",
                    })}
                    labelOrientation="horizontal"
                    labelWidth="150px"
                    options={brazilianCities}
                    validationBlur={validationBlur}
                    isSearchable={true}
                    required
                  />
                </>
              )}
              <TelephoneInputWithLabel
                name="telephone"
                placeholder={intl.formatMessage({
                  id: "telephone",
                })}
                label={intl.formatMessage({
                  id: "telephone",
                })}
                validationBlur={validationBlur}
                labelOrientation="horizontal"
                labelWidth="150px"
                required
              />
            </FieldsContainer>
          </Session>
        </Form>
      </Container>
    </AnimatedMainContainer>
  );
};

export default AdminAssociateCollaboratorsDetail;
